<template>
  <div v-if="awards.length" class="slider-group">
    <div class="header font-body-2">{{ $t(Words.MenuAward) }}</div>
    <div>
      <VueMarquee
        :duration="100"
        clone
        pauseOnHover
      >
        <div v-for="award in awards" :key="award" class="content">
          <v-icon icon="hotel_class" class="mr-3" color="#00000061" />
          <nuxt-link class="font-body link-effect" :to="localePath({name: 'awards'})">
            {{ award }}
          </nuxt-link>
        </div>
      </VueMarquee>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  awards: string[]
}>()

const { awards } = toRefs(props)
const localePath = useLocalePath()
</script>

<style lang="stylus" scoped>
.slider-group
  padding 24px 0
  background $gray-lighten-5
  .header
    text-align center
    color $black-0-6
  .content
    display flex
    align-items center
    padding 16px
    white-space nowrap
    a
      display block
      cursor pointer
</style>